import CustomTable from '@myComponents/CustomTable';
import { ListIncomes } from '../../graphql/Query/incomes';
import { useQuery } from '@apollo/client';
import { columns } from './columns';
import moment from 'moment';

const variables = {
  search: {
    dates: [moment().utc().subtract(30, 'days').toDate(), moment().utc().toDate()],
    q: '',
    perPage: 10,
    page: 1
  }
};

const IncomeList = () => {
  const { data, refetch, loading } = useQuery(ListIncomes, {
    variables
  });
  return (
    <CustomTable
      loading={loading}
      store={data?.listIncomes?.docs || []}
      data={{ ...data?.listIncomes, docs: undefined }}
      refetch={refetch}
      filterOptions={{
        types: [
          {
            id: 'incomes_dates',
            name: 'dates',
            placeholder: 'Seleccionar Fecha',
            type: 'rangepicker'
          }
        ]
      }}
      variables={variables}
      columns={columns({})}
    />
  );
};

export default IncomeList;
